var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommandControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 43.122 39.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6169",
    "data-name": "Group 6169",
    transform: "translate(-244.999 -3810)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19367",
    "data-name": "Path 19367",
    d: "M34.17,50.532a8.876,8.876,0,0,0,4.744-16.377,10.051,10.051,0,0,0-16.864-8.693,8.876,8.876,0,0,0-14.5,7.407A8.876,8.876,0,0,0,8.807,50.532H20.815v5.681a2.944,2.944,0,0,0-2.181,2.181H5.719a2.934,2.934,0,1,0,0,1.347H18.634a2.933,2.933,0,0,0,5.709,0H37.257a2.934,2.934,0,1,0,0-1.347H24.343a2.943,2.943,0,0,0-2.181-2.181V50.532ZM2.865,60.653a1.586,1.586,0,1,1,1.586-1.586,1.586,1.586,0,0,1-1.586,1.586ZM40.11,57.481a1.586,1.586,0,1,1-1.585,1.586,1.586,1.586,0,0,1,1.585-1.586ZM23.075,59.067a1.586,1.586,0,1,1-1.587-1.587,1.586,1.586,0,0,1,1.587,1.587ZM1.279,41.656a7.536,7.536,0,0,1,7.056-7.513.673.673,0,0,0,.625-.766,7.528,7.528,0,0,1,12.656-6.5.675.675,0,0,0,.96-.029,8.707,8.707,0,0,1,14.941,7.528.674.674,0,0,0,.334.711,7.529,7.529,0,0,1-3.68,14.1H8.807a7.537,7.537,0,0,1-7.528-7.528Z",
    transform: "translate(245.074 3787.29)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19368",
    "data-name": "Path 19368",
    d: "M33.572,28.929a5.98,5.98,0,0,0-4.613-2.165.674.674,0,0,1,0-1.347,7.349,7.349,0,0,1,7.22,8.707.674.674,0,0,1-.661.55.705.705,0,0,1-.125-.012.674.674,0,0,1-.539-.786A6,6,0,0,0,33.572,28.929Z",
    transform: "translate(245.074 3787.29)",
    fill: "#f48116",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandControl);
export default __webpack_public_path__ + "static/media/CommandControl.35366d75d4049daad00d7cb96aae9254.svg";
export { ForwardRef as ReactComponent };